import React from 'react';
import { Link } from 'react-router-dom';
import { SectionWrapper } from '../ui/section-wrapper';
import { SectionHeading } from '../ui/section-heading';
import { Badge } from '../ui/badge';
import { products } from '../../data/products';
import stackntrackLogo from '../../assets/logos/Group 80.png';
import evologLogo from '../../assets/logos/applogo_full 2.png';
import slidewithaiLogo from '../../assets/logos/Group 83.png';

const logos: Record<string, string> = {
  stackntrack: stackntrackLogo,
  evolog: evologLogo,
  slidewithai: slidewithaiLogo,
};

const ProductsPreview: React.FC = () => (
  <div className="bg-[#faf8fc]">
    <SectionWrapper id="products-preview" className="py-28 md:py-36">
      <SectionHeading
        label="Portfolio"
        title="Built by us. Powered by AI."
        description="Real products solving real problems, built with the same frameworks we teach."
        variant="light"
      />

      {/* Connected border boxes */}
      <div className="border border-gray-200 rounded-2xl overflow-hidden flex flex-col md:flex-row">
        {products.map((p, i) => (
          <div
            key={p.id}
            className={`flex-1 flex flex-col ${i < products.length - 1 ? 'border-b md:border-b-0 md:border-r border-gray-200' : ''}`}
          >
            {/* Logo area — full width, clickable */}
            <a
              href={p.url}
              target="_blank"
              rel="noopener noreferrer"
              className="block w-full h-40 border-b border-gray-200 group overflow-hidden bg-white"
            >
              <img
                src={logos[p.id]}
                alt={p.name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
              />
            </a>

            {/* Description area */}
            <div className="p-6 flex flex-col items-center gap-2 bg-white text-center">
              <p className="text-gray-500 text-sm">{p.tagline}</p>
              <div className="flex flex-wrap justify-center gap-1.5 mt-2">
                {p.techPills.slice(0, 3).map(pill => (
                  <Badge key={pill} variant="pill" size="sm">{pill}</Badge>
                ))}
              </div>
            </div>
          </div>
        ))}
      </div>

      <div className="text-center mt-10">
        <Link to="/products" className="text-purple-600 hover:text-purple-700 text-sm font-medium transition-colors inline-flex items-center gap-2 group">
          View all products
          <svg className="w-4 h-4 transition-transform group-hover:translate-x-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 8l4 4m0 0l-4 4m4-4H3" />
          </svg>
        </Link>
      </div>
    </SectionWrapper>
  </div>
);

export default ProductsPreview;
